import React from 'react';
import styled from 'styled-components';

import { CardContent } from '@prisjakt/ui/card';
import { BodySmallText, FontEmphasis } from '@prisjakt/ui/text/variants';
import { RankInCategory } from '../rank-in-category';

import { BaseProps } from '../../types';

type Props = Pick<BaseProps, 'rank' | 'previousPriceText' | 'category'>;

export const GridCardProductFooter: React.FC<Props> = props => {
  const { rank, previousPriceText, category } = props;

  return (rank && category) || previousPriceText ? (
    <Footer>
      <RankInCategory category={category} rank={rank} />

      {previousPriceText && (
        <PreviousPriceText emphasis={FontEmphasis.MEDIUM}>
          {previousPriceText}
        </PreviousPriceText>
      )}
    </Footer>
  ) : null;
};

const Footer = styled(CardContent)`
  && {
    padding-top: 0;
    justify-content: end;
  }
`;

const PreviousPriceText = styled(BodySmallText)`
  && {
    flex: 0 1 auto;
  }
`;
